import { render, staticRenderFns } from "./NewComposerInstagram.vue?vue&type=template&id=7ab6c008&scoped=true&"
import script from "./NewComposerInstagram.vue?vue&type=script&lang=js&"
export * from "./NewComposerInstagram.vue?vue&type=script&lang=js&"
import style0 from "vue-slick-carousel/dist/vue-slick-carousel.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./NewComposerInstagram.vue?vue&type=style&index=1&id=7ab6c008&prod&lang=scss&"
import style2 from "./NewComposerInstagram.vue?vue&type=style&index=2&id=7ab6c008&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab6c008",
  null
  
)

export default component.exports